






































































import { VNode } from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import UUIFComponent from '@/shared/uuifComponent';
import { DropdownLight } from '../../../../shared/dropdown-light';
import { required, email } from 'vuelidate/lib/validators';
import { SelectOption } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
import { RootStoreState } from '@/store';
import { InfoState } from '@/core/core.store';
import { State } from 'vuex-class';
import { VueRenderFunction } from '@sonicwall/unified-ui-framework/src/shared/common-types';
import ApiServiceWrapper from '@/shared/api-request.service';
import { SwTable, TableColumnConfig } from '@libs-uuif/shared/sw-table';
import { TableEntry } from '@sonicwall/unified-ui-framework/src/shared/sw-table';

const cssPrefix = 'add-keyset-dialog';

@Component({
  components: {
    ...UUIFComponent,
    DropdownLight,
    SwTable,
  },
  validations: {
    replyTo: { required, email },
    subject: { required },
    desc: { required },
  },
})
export default class AddKeysetDialog extends SwExtendedVue {
  @Prop()
  showAddKeysetDialog: boolean;

  @State((state: RootStoreState) => state.MswProductsStoreModule.productDetails)
  productDetails: any;

  @Prop()
  addKeyResponse : any;

  selectOption: SelectOption[] = [];
  selectedOption: VueRenderFunction | string = 'R';
  submitted: boolean = false;
  replyTo: string = '';
  subject: string = '';
  desc: string = '';
  keysetVersion: any[] = [];
  aventailVersion: string;

  // textbox
  comments: string = '';
  canComment: boolean = false;

  // control for view spike license
  isShowSpikeLicence: boolean = false;
  spikeLicensesData: any[] = [];
  spikeUpgradeServiceId :number = 2929;

  cssPrefix = cssPrefix;
  get getSpikeLicensesData() : TableEntry[] {
    const data: TableEntry[] = [];
    this.spikeLicensesData.forEach((entry, index) => {
      const newEntry: TableEntry = Object.assign({}, entry);
      newEntry._key = index.toString();
      data.push(newEntry);
    });
    return data;
  }
  get spikeLicenceViewConfig(): TableColumnConfig[] {
    return [
      {
        key:'activationDate',
        title: (this.$t('products.actDate')
        .toString()),
        dataKey: 'activationDate',
        /* tslint:disable-next-line */
        render:(h, data): VNode => {
          return (
            <span> {data.entry.startDate} </span>
          ) as VNode;
        },
      },
      {
        key:'users',
        title: (this.$t('products.users')
        .toString()),
        dataKey: 'users',
        /* tslint:disable-next-line */
        render:(h, data): VNode => {
          return (
          <span> {data.entry.nodeCount} </span>
          ) as VNode;
        },
      },
      {
        key:'days',
        title: (this.$t('products.days')
        .toString()),
        dataKey: 'days',
        /* tslint:disable-next-line */
        render:(h, data): VNode => {
          return (
          <span> {data.entry.duration} </span>
          ) as VNode;
        },
      },
      {
        key:'licenceFile',
        title: (this.$t('products.licenseFile')
        .toString()),
        dataKey: 'licenceFile',
        /* tslint:disable-next-line */
        render:(h, data): VNode => {
          return (
           <span style="color:#47afe8;"  onClick={() => { this.downloadKeySet(data.entry.actKey); }}> Download </span>
          ) as VNode;
        },
      },
    ];
  }

  getSpikeLicenceViewData() {
    const request = `product/get-activation-info?serial=${this.productDetails.serialNumber}&serviceID=${this.spikeUpgradeServiceId}`;
    this.$store.dispatch('getSpikeLicenceInfo', request)
      .then((resp) => {
        this.$store.commit('stopLoading');
        if (resp.operationStatus === 'OK' && resp.msgCode === 'MSWAPP:SERVICESTATUSSUCCESS') {
          this.spikeLicensesData = resp.content.activationKeyInfo;
        }
      });
    return this.spikeLicensesData;
  }

  created() {
    const response = this.addKeyResponse.arrKeysetVersion;
    // loading the dictionary of keyset options
    response.forEach((responseUnit: any) => {
      this.keysetVersion.push({
        id: responseUnit.optionName,
        aventailVersion: responseUnit.aventailVersion,
        canComment: responseUnit.isdisplaycomments,
      });
    });

    // loading the keyset licenses options
    let count = 0;
    response.forEach((responseUnit: any) => {
      this.selectOption.push({
        id: count.toString(),
        label: responseUnit.optionName,
        value: responseUnit.aventailVersion,
      });
      count += 1;
    });
    this.selectedOption = this.selectOption[0].id;
    this.aventailVersion = this.keysetVersion[parseInt(this.selectedOption, 10)].aventailVersion;
    this.canComment = this.keysetVersion[parseInt(this.selectedOption, 10)].canComment;
  }

  onKeySetVersionSelect(selectedOption: string) {
    this.comments = '';
    this.aventailVersion = this.keysetVersion[parseInt(selectedOption, 10)].aventailVersion;
    this.canComment = this.keysetVersion[parseInt(selectedOption, 10)].canComment;
  }

  onSubmit() {
    this.$store.commit('startLoading');
    if (this.aventailVersion === '10.5.1*SPIKE') {
      // this.$store.commit('stopLoading');
      this.getSpikeLicenceViewData();
      this.isShowSpikeLicence = true;
    } else {
      const userID = this.$store.getters.getUserId;
      const serialNumber = this.productDetails.serialNumber;
      const request = {
        tenant: userID,
        tileName: 'LICENSEKEYSET',
      };
      this.$store.dispatch('MswProductsStoreModule/generateCSCCode', request)
      .then((resp: any) => {
        if (resp?.operationStatus === 'OK' && (resp?.content?.accessCode !== '')) {
          const { accessCode } = resp?.content;
          const redirectURL =
          // tslint:disable-next-line:max-line-length
          `product/licensesKeyset?username=${userID}&strAccessCode=${accessCode}&serial=${serialNumber}&aventailVersion=${this.aventailVersion}&strComments=${this.canComment}`;
          ApiServiceWrapper.replaceTiltPipe(redirectURL);
          this.$store.commit('stopLoading');
          this.closeDialog();
        } else {
          const message: InfoState = { infoType: 'failed', infoMsg: resp?.msgDesc || '' };
          this.$store.commit('enqueueMessage', message);
        }
      })
      .catch((errorRespose: any) => {
        this.$store.commit('stopLoading');
        console.error(errorRespose);
      });
    }
  }
  closeDialog() {
    this.isShowSpikeLicence = false;
    this.$emit('closeDialog');
  }
  downloadKeySet(key: any) {
    const userID = this.$store.getters.getUserId;
    const serialNumber = this.productDetails.serialNumber;
    const request = {
      tenant: userID,
      tileName: 'LICENSEKEYSET',
    };
    this.$store.dispatch('MswProductsStoreModule/generateCSCCode', request)
    .then((resp: any) => {
      if (resp?.operationStatus === 'OK' && (resp?.content?.accessCode !== '')) {
        const { accessCode } = resp?.content;
        const redirectURL =
        // tslint:disable-next-line:max-line-length
        `product/licensesKeyset?username=${userID}&strAccessCode=${accessCode}&serial=${serialNumber}&aventailVersion=${this.aventailVersion}&strComments=${this.canComment}&strActivationKey=${key}`;
        ApiServiceWrapper.replaceTiltPipe(redirectURL);
        this.closeDialog();
      } else {
        const message: InfoState = { infoType: 'failed', infoMsg: resp?.msgDesc || '' };
        this.$store.commit('enqueueMessage', message);
      }
    })
    .catch((errorRespose: any) => {
      this.$store.commit('stopLoading');
      console.error(errorRespose);
    });
  }
}
